import { spaceTypes } from '../spaceTypes';
import countries from 'constants/countries';
import { getSize, getInOfficeHeadcountBasedQuantites, getFixedQuantities } from './utils';

export const opencollaboration = [
  {
    id: 13,
    name: 'spaceTypes.openCollaboration.openCollaboration',
    displayOrder: 1,
    spaceTypeId: spaceTypes.opencollaboration.id,
    size: {
      [countries.US]: getSize(10.0, 10.0),
      [countries.UK]: getSize(10.0, 10.0),
      [countries.FR]: getSize(1.5, 1.5),
      [countries.EU]: getSize(3.0, 3.0),
      [countries.DE]: getSize(3.0, 3.0),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(100, 100, 100),
      [countries.UK]: getInOfficeHeadcountBasedQuantites(100, 100, 100),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(100, 100, 100),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(100, 100, 100),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(100, 100, 100),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499755/insite/qa/spaces/n2kzmtcsdjaiaxiqadzp.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499755/insite/qa/spaces/n2kzmtcsdjaiaxiqadzp.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499755/insite/qa/spaces/n2kzmtcsdjaiaxiqadzp.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499755/insite/qa/spaces/n2kzmtcsdjaiaxiqadzp.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499755/insite/qa/spaces/n2kzmtcsdjaiaxiqadzp.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 1276,
    name: 'spaceTypes.openCollaboration.teamingTable',
    displayOrder: 2,
    spaceTypeId: spaceTypes.opencollaboration.id,
    size: {
      [countries.US]: getSize(10.0, 10.0),
      [countries.UK]: getSize(10.0, 10.0),
      [countries.FR]: getSize(2.8, 2.8),
      [countries.EU]: getSize(3.5, 4.0),
      [countries.DE]: getSize(3.5, 4.0),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
      [countries.UK]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818134/insite/qa/spaces/yapxuay3acpugvybv5qk.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818134/insite/qa/spaces/yapxuay3acpugvybv5qk.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818134/insite/qa/spaces/yapxuay3acpugvybv5qk.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818134/insite/qa/spaces/yapxuay3acpugvybv5qk.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818134/insite/qa/spaces/yapxuay3acpugvybv5qk.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 1277,
    name: 'spaceTypes.openCollaboration.teamingLounge',
    displayOrder: 3,
    spaceTypeId: spaceTypes.opencollaboration.id,
    size: {
      [countries.US]: getSize(10.0, 10.0),
      [countries.UK]: getSize(10.0, 10.0),
      [countries.FR]: getSize(3.0, 3.0),
      [countries.EU]: getSize(4.0, 4.0),
      [countries.DE]: getSize(4.0, 4.0),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(100, 100, 50),
      [countries.UK]: getFixedQuantities(0),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(100, 100, 50),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(50, 100, 100),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(50, 100, 100),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499768/insite/qa/spaces/gvesgkjgs8jb13jstqby.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499768/insite/qa/spaces/gvesgkjgs8jb13jstqby.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499768/insite/qa/spaces/gvesgkjgs8jb13jstqby.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499768/insite/qa/spaces/gvesgkjgs8jb13jstqby.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499768/insite/qa/spaces/gvesgkjgs8jb13jstqby.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 1278,
    name: 'spaceTypes.openCollaboration.1on1Seating',
    displayOrder: 4,
    spaceTypeId: spaceTypes.opencollaboration.id,
    size: {
      [countries.US]: getSize(9.0, 8.0),
      [countries.UK]: getSize(9.0, 8.0),
      [countries.FR]: getSize(1.5, 2.5),
      [countries.EU]: getSize(2.0, 3.5),
      [countries.DE]: getSize(2.0, 3.5),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(100, 100, 50),
      [countries.UK]: getInOfficeHeadcountBasedQuantites(100, 100, 50),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(100, 100, 50),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(50, 100, 100),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(50, 100, 100),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499769/insite/qa/spaces/ryezjoy1tghvoagej7r5.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499769/insite/qa/spaces/ryezjoy1tghvoagej7r5.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499769/insite/qa/spaces/ryezjoy1tghvoagej7r5.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499769/insite/qa/spaces/ryezjoy1tghvoagej7r5.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499769/insite/qa/spaces/ryezjoy1tghvoagej7r5.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 1279,
    name: 'spaceTypes.openCollaboration.mediaTeaming',
    displayOrder: 5,
    spaceTypeId: spaceTypes.opencollaboration.id,
    size: {
      [countries.US]: getSize(12.0, 10.0),
      [countries.UK]: getSize(12.0, 10.0),
      [countries.FR]: getSize(4.5, 4.5),
      [countries.EU]: getSize(5.0, 6.0),
      [countries.DE]: getSize(5.0, 6.0),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(100, 50, 30),
      [countries.UK]: getInOfficeHeadcountBasedQuantites(100, 50, 100),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(100, 50, 30),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(30, 100, 50),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(30, 100, 50),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499770/insite/qa/spaces/cezm8unyp9jktovej3ej.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499770/insite/qa/spaces/cezm8unyp9jktovej3ej.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499770/insite/qa/spaces/cezm8unyp9jktovej3ej.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499770/insite/qa/spaces/cezm8unyp9jktovej3ej.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499770/insite/qa/spaces/cezm8unyp9jktovej3ej.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 1280,
    name: 'spaceTypes.openCollaboration.boothSeating',
    displayOrder: 6,
    spaceTypeId: spaceTypes.opencollaboration.id,
    size: {
      [countries.US]: getSize(15.0, 5.0),
      [countries.UK]: getSize(15.0, 5.0),
      [countries.FR]: getSize(2.5, 3.0),
      [countries.EU]: getSize(3.0, 4.0),
      [countries.DE]: getSize(3.0, 4.0),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(100, 50, 30),
      [countries.UK]: getInOfficeHeadcountBasedQuantites(100, 50, 60),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(100, 50, 30),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(30, 100, 50),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(30, 100, 50),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499772/insite/qa/spaces/cxogxsurukfrs6wduwbk.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499772/insite/qa/spaces/cxogxsurukfrs6wduwbk.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499772/insite/qa/spaces/cxogxsurukfrs6wduwbk.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499772/insite/qa/spaces/cxogxsurukfrs6wduwbk.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499772/insite/qa/spaces/cxogxsurukfrs6wduwbk.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
];
